import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyDto, PropertyLocationDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyLocationDisplayComponent } from '../display/location-display.component';
import { PropertyLocationFormComponent } from '../form/location-form.component';

@Component({
  selector: 'etxe-property-location-edit',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyLocationDisplayComponent,
    PropertyLocationFormComponent,
  ],
  templateUrl: './location-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyLocationEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  allowEdit = input<boolean>(false);
  saving = input<boolean>(false);

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyLocationDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyLocationDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
